import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
// import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
// import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
// import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
// import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
// import SendRoundedIcon from '@mui/icons-material/SendRounded';
// import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
// import { ExternalLinkFormatter } from 'components/shared/routing/LinkFormatter';
import liq_badge from '../assets/vectors/LIQ_badge.png';

const Banner = () => {
    const bgImg = 'bg-[url(/public/banner-network-image.jpg)] bg-cover bg-no-repeat bg-center';
    return (
        <div className={'h-[100vh] ' + bgImg}>
            <div className="pt-12 flex flex-col justify-center h-full bg-[#152353]/75 lg:px-32">
                <div className="grid grid-cols-4 gap-6 lg:p-16 p-6 my-24">
                    <div className="lg:col-span-3 col-span-4 flex flex-col gap-12 text-liq-white">
                        <div className="flex flex-col gap-8">
                            <div className="flex flex-row items-center lg:gap-4 gap-2">
                                <img
                                    src={liq_badge}
                                    className="aspect-square lg:w-24 w-16"
                                    alt="logo"
                                />
                                <h1 className="lg:text-7xl text-2xl">
                                    Lobby<span className="font-black">IQ</span>
                                </h1>
                            </div>
                            <h2 className="lg:text-5xl text-2xl lg:leading-[3rem]">
                                Critical Intelligence for Government Relations and Parliamentary
                                Affairs
                            </h2>
                        </div>
                        <p className="text-xl">
                            LobbyIQ helps organizations effortlessly navigate the complex landscape
                            of government relations and parliamentary affairs through the power of
                            AI-driven analytics. Track custom issues, monitor committees in real
                            time, and leverage dashboard data-analytics.
                        </p>
                        <Button
                            component={Link}
                            to="/contact"
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            className="lg:w-72"
                        >
                            <div className="py-1 lg:text-lg">Request a Call</div>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ContactBanner = () => {
    const bgImg =
        'rounded-2xl shadow-xl bg-[url(/public/banner-circuit-image.jpg)] bg-cover bg-no-repeat bg-center';
    return (
        <div className={bgImg}>
            <div className="flex flex-col gap-4 items-center p-12 text-liq-white bg-gradient-to-r from-[#00537D] to-[#152353]">
                <div className="text-center mb-12">
                    <h2 className="text-2xl lg:text-4xl font-bold text-white text-center">
                        Interested in Learning More About LobbyIQ?
                    </h2>
                </div>
                <Button
                    component={Link}
                    to="/contact"
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    className="w-64"
                >
                    <div className="py-1 lg:text-lg text-white">Request a Call</div>
                </Button>
            </div>
        </div>
    );
};

// const IssueTracker = () => {
//     return (
//         <div className="flex flex-col gap-24 lg:px-48 py-12" id="issue-tracker">
//             <div className="lg:text-center text-left">
//                 <h2 className="text-2xl lg:text-5xl font-bold">
//                     Automatic <span className="text-red-500 underline">Daily Alerts</span> on your
//                     custom-curated issues
//                 </h2>
//                 <p className="pt-6 lg:text-2xl text-xl">
//                     LobbyIQ's unique custom issue dashboards allow clients to easily define key
//                     issues and monitor their discussion in parliament.
//                 </p>
//                 <div className="pt-6 flex flex-row lg:justify-center">
//                     <Button
//                         component={Link}
//                         to="/contact"
//                         endIcon={<ArrowForwardIcon />}
//                         size="large"
//                     >
//                         Request a Call
//                     </Button>
//                 </div>
//             </div>

//             <div className="grid grid-cols-2 gap-24">
//                 <div className="lg:col-span-1 col-span-2 flex flex-col gap-16">
//                     <div className="flex flex-row gap-4">
//                         <div>
//                             <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                 <NotificationsNoneRoundedIcon sx={{ color: '#e04136' }} />
//                             </div>
//                         </div>
//                         <div>
//                             <h3 className="text-2xl font-bold">Daily Keyword Alerts</h3>
//                             <p className="pt-2 text-xl">
//                                 Clients can receive daily emails whenever issue keywords are
//                                 mentioned in Hansard, House Committees, Senate Committees,
//                                 Stakeholder Briefs, News Releases, or Lobby Registrations.
//                             </p>
//                         </div>
//                     </div>

//                     <div className="flex flex-row gap-4">
//                         <div>
//                             <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                 <DashboardRoundedIcon sx={{ color: '#e04136' }} />
//                             </div>
//                         </div>
//                         <div>
//                             <h3 className="text-2xl font-bold">Custom Issue Dashboards</h3>
//                             <p className="pt-2 text-xl">
//                                 Easily define key issues and monitor their discussion in parliament.
//                                 Issue dashboards also track stakeholder lobbying on issues, based on
//                                 keywords included in lobby registrations.
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="lg:col-span-1 col-span-2 lg:pl-12">
//                     <img
//                         src={process.env.PUBLIC_URL + '/issue_tracker_banner_img.png'}
//                         className="w-full h-full"
//                         style={{ objectFit: 'contain' }}
//                         alt=""
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// const CommitteeMonitor = () => {
//     const bgImg = 'bg-[url(/public/banner-network2-image.jpg)] bg-cover bg-no-repeat bg-center';
//     return (
//         <div className={bgImg}>
//             <div className="bg-[#152353]/90 lg:px-48 px-6 py-32 text-liq-white">
//                 <div className="max-w-[75rem] mx-auto flex flex-col gap-24">
//                     <div className="lg:text-center text-left">
//                         <h2 className="text-2xl lg:text-5xl font-bold">
//                             Committee Meeting{' '}
//                             <span className="text-purple-300 underline">
//                                 Summaries and Transcripts
//                             </span>
//                         </h2>
//                         <p className="pt-6 lg:text-2xl text-xl">
//                             House and Senate Committee meeting transcripts and summaries within an
//                             hour of a meeting ending.
//                         </p>
//                         <div className="pt-6 flex flex-row lg:justify-center">
//                             <Button component={Link} to="/pricing/committee" size="large">
//                                 <span className="text-sky-200">Subscribe</span>
//                             </Button>
//                         </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-24">
//                         <div className="lg:col-span-1 col-span-2 flex flex-col gap-16">
//                             <div className="flex flex-row gap-4">
//                                 <div>
//                                     <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                         <GroupsRoundedIcon sx={{ color: '#7f24ff' }} />
//                                     </div>
//                                 </div>
//                                 <div>
//                                     <h3 className="text-2xl font-bold">
//                                         House and Senate Committee Meetings
//                                     </h3>
//                                     <p className="pt-2 text-xl">
//                                         LobbyIQ is the only organization that provides summaries and
//                                         transcripts of House and Senate committee meetings within an
//                                         hour of the meeting ending.
//                                     </p>
//                                 </div>
//                             </div>

//                             <div className="flex flex-row gap-4">
//                                 <div>
//                                     <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                         <EventAvailableRoundedIcon sx={{ color: '#7f24ff' }} />
//                                     </div>
//                                 </div>
//                                 <div>
//                                     <h3 className="text-2xl font-bold">Subscribe and Monitor</h3>
//                                     <p className="pt-2 text-xl">
//                                         Clients can subscribe to monitor any number of committees
//                                         for periods of 6 or 12 months. The summaries and transcripts
//                                         of each committee meeting are automatically emailed to
//                                         clients after each meeting.
//                                     </p>
//                                     <p className="font-bold py-3">Examples: </p>
//                                     <ul className="list-disc pl-6">
//                                         <li>
//                                             <Link
//                                                 target="_blank"
//                                                 to="/Summary_TRAN_145.pdf"
//                                                 className="text-sky-200 hover:underline"
//                                             >
//                                                 TRAN Meeting 145 Summary
//                                             </Link>
//                                         </li>
//                                         <li>
//                                             <Link
//                                                 target="_blank"
//                                                 to="/Transcript_TRAN_145.pdf"
//                                                 className="text-sky-200 hover:underline"
//                                             >
//                                                 SECU Meeting 136 Transcript
//                                             </Link>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="lg:col-span-1 col-span-2">
//                             <img
//                                 src={process.env.PUBLIC_URL + '/committee_banner_img.png'}
//                                 className="w-full h-full"
//                                 style={{ objectFit: 'contain' }}
//                                 alt=""
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const ProfileDashboards = () => {
//     return (
//         <div className="flex flex-col gap-24 lg:px-48 py-12" id="profile-dashboards">
//             <div className="lg:text-center text-left">
//                 <h2 className="text-2xl lg:text-5xl font-bold">
//                     Track lobbying activities across sectors, organizations, and government entities
//                     with <span className="text-blue-500 underline">real-time analytics</span> and
//                     actionable insights.
//                 </h2>
//                 <p className="pt-6 lg:text-2xl text-xl">
//                     LobbyIQ's unique curated dashboards provide detailed real-time analytics on
//                     lobbying
//                 </p>
//                 <div className="pt-6 flex flex-row lg:justify-center">
//                     <Button
//                         component={Link}
//                         to="/contact"
//                         endIcon={<ArrowForwardIcon />}
//                         size="large"
//                     >
//                         Request a Call
//                     </Button>
//                 </div>
//             </div>

//             <div className="grid grid-cols-2 gap-24">
//                 <div className="lg:col-span-1 col-span-2 flex flex-col gap-16">
//                     <div className="flex flex-row gap-4">
//                         <div>
//                             <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                 <BusinessCenterRoundedIcon sx={{ color: '#2965ff' }} />
//                             </div>
//                         </div>
//                         <div>
//                             <h3 className="text-2xl font-bold">
//                                 <ExternalLinkFormatter
//                                     urlLink="/sectors"
//                                     urlTitle="Sector and Organization Lobbying"
//                                 />
//                             </h3>
//                             <p className="pt-2 text-xl">
//                                 LobbyIQ's unique curated dashboards provide detailed real-time
//                                 analytics on lobbying by Sectors and Organizations, offering instant
//                                 insights on stakeholder trends and strategies.
//                             </p>
//                         </div>
//                     </div>

//                     <div className="flex flex-row gap-4">
//                         <div>
//                             <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                 <SendRoundedIcon sx={{ color: '#2965ff' }} />
//                             </div>
//                         </div>
//                         <div>
//                             <h3 className="text-2xl font-bold">
//                                 <ExternalLinkFormatter
//                                     urlLink="https://liqtranscripts.blob.core.windows.net/summary/LobbyIQSampleWeeklyEmail.pdf"
//                                     urlTitle="Lobby Update Emails"
//                                 />
//                             </h3>
//                             <p className="pt-2 text-xl">
//                                 Clients can opt to receive weekly and monthly email updates on
//                                 lobbying activity by sector, institution, organization, and DPOH.
//                             </p>
//                         </div>
//                     </div>

//                     <div className="flex flex-row gap-4">
//                         <div>
//                             <div className="w-10 h-10 flex flex-row items-center justify-center rounded-md bg-slate-200">
//                                 <AccountBalanceRoundedIcon sx={{ color: '#2965ff' }} />
//                             </div>
//                         </div>
//                         <div>
//                             <h3 className="text-2xl font-bold">
//                                 <ExternalLinkFormatter
//                                     urlLink="/institutions"
//                                     urlTitle="
//                                 Monitor MPs, Institutions, DPOHs, and Committees"
//                                 />
//                             </h3>
//                             <p className="pt-2 text-xl">
//                                 MP, Institution, DPOH, and Committee dashboards provide metrics on
//                                 who in government is lobbied and by whom.
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="lg:col-span-1 col-span-2 lg:pl-12">
//                     <img
//                         src={process.env.PUBLIC_URL + '/profile_dashboard_banner_img.png'}
//                         className="w-full h-full"
//                         style={{ objectFit: 'contain' }}
//                         alt=""
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// const Solutions = () => {
//     const bgImg = 'bg-[url(/public/banner-circuit-image.jpg)] bg-cover bg-no-repeat bg-center';
//     return (
//         <div className={bgImg}>
//             <div className="bg-[#152353]/90 lg:px-48 px-6 py-32 text-liq-white">
//                 <div className="max-w-[90rem] mx-auto flex flex-col gap-24">
//                     <h2 className="text-3xl lg:text-5xl font-bold">Other Services</h2>
//                     <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
//                         <div className="flex flex-col gap-8">
//                             <h3 className="text-2xl font-bold">Stay Ahead Updates</h3>
//                             <div className="border-l-2 border-white px-6 flex flex-col justify-between gap-6 min-h-[200px]">
//                                 <p>
//                                     Receive weekly lobbying updates and keyword alerts, plus monthly
//                                     summaries of key issues and stakeholders.
//                                 </p>
//                                 <h4 className="text-xl">
//                                     Same-Day{' '}
//                                     <Link
//                                         to="https://liqtranscripts.blob.core.windows.net/summary/AGRI_2024-02-27.pdf"
//                                         className="text-sky-300"
//                                     >
//                                         Committee Meeting Summaries
//                                     </Link>
//                                 </h4>
//                                 <p>
//                                     Tired of waiting two weeks to obtain transcripts from critical
//                                     committee minutes? We deliver full meeting transcripts and
//                                     2-page summaries to your inbox within the hour of the meeting.
//                                 </p>
//                                 <h4 className="text-xl">
//                                     <Link
//                                         to="https://liqtranscripts.blob.core.windows.net/summary/LobbyIQSampleWeeklyEmail.pdf"
//                                         className="text-sky-300"
//                                     >
//                                         Weekly Lobby Monitor Emails
//                                     </Link>
//                                 </h4>
//                                 <p>
//                                     Receive a weekly list of all lobby communications and
//                                     registrations in your core areas of focus: by sector,
//                                     organization, institution, public office holders.
//                                 </p>
//                                 <h4 className="text-xl">Keyword Alerts</h4>
//                                 <p>
//                                     We send email alerts for mentions of critical keywords for
//                                     Reputation Risk and Crisis Management.
//                                 </p>
//                                 <h4 className="text-xl">Weekly Issue Emails</h4>
//                                 <p>
//                                     We send weekly email summaries of lobbying on your issues, as
//                                     well as full-sentence extracts of parliamentary discussions.
//                                 </p>
//                             </div>
//                         </div>

//                         <div className="flex flex-col gap-8">
//                             <h3 className="text-2xl font-bold">Research Hub</h3>
//                             <div className="border-l-2 border-white px-6 flex flex-col justify-between gap-6 min-h-[200px]">
//                                 <p>
//                                     Analyze cleaned lobbying data, compare 15 years of GR activity,
//                                     and generate presentation-ready charts and tables.
//                                 </p>
//                                 <h4 className="text-xl">
//                                     Download Custom{' '}
//                                     <Link to="/custom-query" className="text-sky-300">
//                                         Lobbying Data
//                                     </Link>
//                                 </h4>
//                                 <p>
//                                     Flexible custom queries to download all communications or
//                                     registrations by any desired data-angle, e.g. by Sector and DPOH
//                                 </p>
//                                 <h4 className="text-xl">On Demand AI-Enabled Text-Mining</h4>
//                                 <p>
//                                     Use our AI-enabled tech-stack to analyze and summarize any kind
//                                     of government texts (legal, regulatory etc)
//                                 </p>
//                                 <h4 className="text-xl">Wayback Machine</h4>
//                                 <p>
//                                     Research changes: with our Wayback machine you can re-populate
//                                     any dashboard to he current state of affairs at any time since
//                                     2010
//                                 </p>
//                                 <h4 className="text-xl">PDF Generator</h4>
//                                 <p>
//                                     Create presentation-ready charts and tables for presentations
//                                     and handouts.
//                                 </p>
//                             </div>
//                         </div>

//                         <div className="flex flex-col gap-8">
//                             <h3 className="text-2xl font-bold">GR Insider</h3>
//                             <div className="border-l-2 border-white px-6 flex flex-col justify-between gap-6 min-h-[200px]">
//                                 <p>
//                                     Assess GR firm market positions, track consultant client
//                                     engagements, and identify business development opportunities.
//                                 </p>
//                                 <h4 className="text-xl">
//                                     <Link to="/firms" className="text-sky-300">
//                                         Government Relation Firms
//                                     </Link>
//                                 </h4>
//                                 <p>
//                                     GR firm dashboards provide real-time analytics on lobbying by
//                                     hundreds of firms: the clients and sectors they represent, their
//                                     consultants, and the institutions and DPOHs they lobby.
//                                 </p>
//                                 <h4 className="text-xl">
//                                     <Link
//                                         to="/firms/PAA%20Advisory%20%7C%20Conseils/consultants?firm=PAA%20Advisory%20%7C%20Conseils"
//                                         className="text-sky-300"
//                                     >
//                                         Consultants
//                                     </Link>
//                                 </h4>
//                                 <p>
//                                     Consultant dashboards provide real-time analytics on clients,
//                                     registrations and lobbying activity. Registration-level
//                                     dashboards offer insights on individual client engagements.
//                                 </p>
//                                 <h4 className="text-xl">GR Insider Email</h4>
//                                 <p>
//                                     The weekly GR Insider email keeps GR professionals up to date on
//                                     the changing landscape of lobby registrations and
//                                     de-registrations by organizations, GR firms and consultants, as
//                                     well as on changes to in-house GR teams.
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

const issueTitle = 'Effortlessly stay ahead on your key issues';
const issuePara1 =
    "LobbyIQ's <b>Issue Tracker</b> automatically monitors dozens of government sources each day for mentions of client-defined issues, keeping clients informed in real-time through email updates.";

const issuePara2 =
    '<b>Issue dashboards</b> provide accessible insights and intelligence, giving government relations professionals a competitive edge on issues that matter.';

const committeeTitle = 'Never miss another Committee meeting';
const committeePara1 =
    "LobbyIQ's <b>Committee Monitor</b> transcribes and summarizes House and Senate Committee meetings, delivering them to clients within minutes of the meeting ending. Witness-level summaries and sentiment analysis provide added insight on Committee proceedings.";

const insightTitle = 'Gain critical intelligence and insight';
const insightPara1 =
    "LobbyIQ's unique curated <b>MP and Senator dashboards</b> provide real-time summaries of MP and Senator discourse in parliament and social media, and on which organizations are lobbying them.";
const insightPara2 =
    '<b>Organization, Sector, DPOH, and Institution dashboards</b> provide analytics on who is lobbying whom, offering instant insights on stakeholder trends and strategies.';
const insightPara3 =
    '<b>GR Firm dashboards</b>  give competitive intelligence on client engagements and who has access on Parliament Hill.';

const researchTitle = 'Save time on research and meeting preparation';
const researchPara1 =
    "LobbyIQ's <b>GR Search Engine</b>, enhanced <b>Lobby Data Search</b> filter and curated <b>dashboards</b> offer unparalleled data analytics for issue analysis and background research.";

const Row = ({
    title,
    para1,
    para2,
    para3,
    bgImg = undefined,
}: {
    title: string;
    para1: string;
    para2: string;
    para3: string;
    bgImg?: string;
}) => {
    return (
        <div className={bgImg ? bgImg + ' bg-cover bg-no-repeat bg-center' : ''}>
            <div
                className={
                    (bgImg ? 'bg-[#152353]/90 text-liq-white ' : '') +
                    'lg:px-48 px-6 lg:py-48 py-12'
                }
            >
                <div className="max-w-[75rem] mx-auto grid grid-cols-3 lg:gap-24 gap-4">
                    <div className="lg:col-span-1 col-span-3">
                        <h2 className="lg:text-5xl text-3xl font-bold">{title}</h2>
                    </div>
                    <div className="lg:col-span-2 col-span-3 flex flex-col gap-6">
                        <p dangerouslySetInnerHTML={{ __html: para1 }} className="text-2xl"></p>
                        <p dangerouslySetInnerHTML={{ __html: para2 }} className="text-2xl"></p>
                        <p dangerouslySetInnerHTML={{ __html: para3 }} className="text-2xl"></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Landing = () => {
    return (
        <div id="top">
            <div className="shadow-xl">
                <Banner />
            </div>

            <div className="grid grid-cols-12 mx-auto max-w-[100rem]">
                <div className="col-start-1 col-end-13">
                    <Row title={issueTitle} para1={issuePara1} para2={issuePara2} para3="" />
                </div>
            </div>

            <div className="shadow-xl">
                <Row
                    title={committeeTitle}
                    para1={committeePara1}
                    para2=""
                    para3=""
                    bgImg="bg-[url(/public/banner-network2-image.jpg)]"
                />
            </div>

            <div className="grid grid-cols-12 mx-auto max-w-[100rem]">
                <div className="col-start-1 col-end-13">
                    <Row
                        title={insightTitle}
                        para1={insightPara1}
                        para2={insightPara2}
                        para3={insightPara3}
                    />
                </div>
            </div>

            <div className="shadow-xl">
                <Row
                    title={researchTitle}
                    para1={researchPara1}
                    para2=""
                    para3=""
                    bgImg="bg-[url(/public/banner-circuit-image.jpg)]"
                />
            </div>

            {/*
            <div className="grid grid-cols-12 mx-auto max-w-[100rem]">
                <div className="col-start-1 col-end-13 py-16 lg:m-0 mx-4">
                    <IssueTracker />
                </div>
            </div>

            <div className="shadow-xl my-24">
                <CommitteeMonitor />
            </div>

            <div className="grid grid-cols-12 mx-auto max-w-[100rem]">
                <div className="col-start-1 col-end-13 py-16 lg:m-0 mx-4">
                    <ProfileDashboards />
                </div>
            </div>

            <div className="shadow-xl my-24">
                <Solutions />
            </div>
            */}

            <div className="mt-24">
                <ContactBanner />
            </div>
        </div>
    );
};

export default Landing;

/* 

    <div className="pt-64 lg:col-start-2 lg:col-end-12 col-start-2 col-end-12 flex flex-col gap-10">
        <div className="text-black text-2xl lg:text-4xl mt-10"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:gap-12 md:gap-8 gap-8">
            <div className="bg-white rounded-md shadow-md flex flex-col items-center">
                <Link
                    to="/features/updates"
                    className="w-full block bg-liq-lime text-white lg:text-2xl text-md font-semibold py-3 rounded-t-md hover:bg-white hover:text-liq-lime border-2 border-liq-lime transition-all group text-center"
                >
                    Stay Ahead Updates
                    <ArrowForwardIcon className="ml-2 transition-colors group-hover:text-liq-lime" />
                </Link>
                <div className="flex-1 flex items-center justify-center p-8">
                    <img
                        src={process.env.PUBLIC_URL + '/Landing_Stay_Ahead_Icon.png'}
                        alt="Stay Ahead Updates"
                        className="block h-full w-full rounded-md object-contain max-w-[220px] max-h-[220px]"
                    />
                </div>
                <div className="px-8 pb-8 text-sm lg:text-xl">
                    Receive weekly lobbying updates and keyword alerts, plus monthly
                    summaries of key issues and stakeholders.
                </div>
            </div>

            <div className="bg-white rounded-md shadow-md flex flex-col items-center">
                <Link
                    to="/features/research"
                    className="w-full block bg-liq-teal text-white lg:text-2xl font-semibold py-3 rounded-t-md hover:bg-white hover:text-liq-teal border-2 border-liq-teal transition-all group text-center"
                >
                    Research Hub
                    <ArrowForwardIcon className="ml-2 transition-colors group-hover:text-liq-teal" />
                </Link>
                <div className="flex-1 flex items-center justify-center p-8">
                    <img
                        src={process.env.PUBLIC_URL + '/Landing_Research_Hub_Icon.png'}
                        alt="Research Hub"
                        className="block h-full w-full rounded-md object-contain max-w-[220px] max-h-[220px]"
                    />
                </div>
                <div className="px-8 pb-8 text-sm lg:text-xl">
                    Analyze cleaned lobbying data, compare 15 years of GR activity, and
                    generate presentation-ready charts and tables.
                </div>
            </div>

            <div className="bg-white rounded-md shadow-md flex flex-col items-center">
                <Link
                    to="/features/gr-insider"
                    className="w-full block bg-liq-lavender text-white lg:text-2xl font-semibold py-3 rounded-t-md hover:bg-white hover:text-liq-lavender border-2 border-liq-lavender transition-all group text-center"
                >
                    GR Insider
                    <ArrowForwardIcon className="ml-2 transition-colors group-hover:text-liq-lavender" />
                </Link>
                <div className="flex-1 flex items-center justify-center p-8">
                    <img
                        src={process.env.PUBLIC_URL + '/Landing_GR_Insider_Icon.png'}
                        alt="GR Insider"
                        className="block h-full w-full rounded-md object-contain max-w-[220px] max-h-[220px]"
                    />
                </div>
                <div className="px-8 pb-8 text-sm lg:text-xl">
                    Assess GR firm market positions, track consultant client
                    engagements, and identify business development opportunities.
                </div>
            </div>
        </div>
    </div>
*/
